// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import {
  Record,
  Feature,
  DateUtils,
} from '@fulcrumapp/fulcrum-core';
import MetadataField from './metadata-field';

export default class TimestampField extends MetadataField {
  static propTypes = {
    ...MetadataField.propTypes,
    record: PropTypes.instanceOf(Record).isRequired,
    feature: PropTypes.instanceOf(Feature).isRequired,
    label: PropTypes.string,
    part: PropTypes.string,
  };

  renderLabelContent() {
    const { styles } = TimestampField;

    return (
      <span>
        <strong className={MetadataField.styles.strong}>{this.props.label}</strong>
        <span className={styles.partLabel}>
          {' '}
          (
          {this.props.part}
          )
        </span>
      </span>
    );
  }

  renderValueContent() {
    return (
      <span>
        {this.props.feature[this.props.field] && this.renderTimestamp()}
        {this.props.feature[this.props.field] && this.renderRelativeTimestamp()}
        {this.renderUser()}
      </span>
    );
  }

  renderTimestamp() {
    const date = this.props.feature[this.props.field];

    return DateUtils.formatLocalizedTimestamp(date);
  }

  renderRelativeTimestamp() {
    const { styles } = TimestampField;

    const date = this.props.feature[this.props.field];

    return (
      <span className={css(styles.relativeTimestamp)}>
        {DateUtils.formatRelativeTimestamp(date)}
      </span>
    );
  }

  renderUser() {
    const userAttribute = this.props.field.match(/created/i) ? 'createdByName' : 'updatedByName';

    const user = this.props.feature[userAttribute];

    return user ? `by ${user}` : null;
  }
}

const styles = cssInJS({
  partLabel: {
    color: '#888',
  },

  relativeTimestamp: {
    color: '#888',
    marginLeft: 3,
    marginRight: 3,
  },
});

TimestampField.styles = styles;
